<div [formGroup]="companyForm">
  @if (showClientDataTab) {
    <div class="row pb-3">
      <div class="col">
        <div class="client-info-tabs">
          <button
            type="button"
            class="folder-tab"
            [class.active]="isCompanyInfoTabActive"
            (click)="setActiveClientInfoTab('companyInfo')"
          >
            Company Info
          </button>
          <button
            type="button"
            class="folder-tab"
            [class.active]="isClientListDataTabActive"
            (click)="setActiveClientInfoTab('clientListData')"
          >
            Client List Data
            <span class="beta-pill">
              <i class="bi bi-flask"></i>
              VIVE labs
            </span>
          </button>
          <button
            type="button"
            class="folder-tab"
            [class.active]="isLifecycleDatesTabActive"
            (click)="setActiveClientInfoTab('lifecycleDates')"
          >
            Lifecycle Dates
            <span class="beta-pill">
              <i class="bi bi-flask"></i>
              VIVE labs
            </span>
          </button>
        </div>
      </div>
    </div>
  }

  @if (isCompanyInfoTabActive) {
    <div class="row pb-3">
      <div class="col">
        <app-display-card>
          <div class="inner-panel rounded">
            <h3>Company Information</h3>
            <div class="row">
              <div class="col">
                <div class="row g-3">
                  <div class="col-4">
                    <label for="legalName" class="form-label" requiredAsterisk
                      >Legal Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="legalName"
                      formControlName="legalName"
                    />
                  </div>
                  <div class="col-4">
                    <label for="dba" class="form-label">DBA</label>
                    <input
                      type="text"
                      class="form-control"
                      id="dba"
                      formControlName="dba"
                    />
                  </div>
                  <div class="col-4">
                    <label for="phone" class="form-label">Office Phone</label>
                    <input
                      type="tel"
                      class="form-control"
                      id="phone"
                      placeholder="(___) ___-____"
                      [inputMask]="phoneMask"
                      formControlName="phone"
                    />
                  </div>
                  <div class="col-4">
                    <label for="taxStructure" class="form-label"
                      >Tax Structure</label
                    >
                    <select
                      id="taxStructure"
                      class="form-select"
                      formControlName="structure"
                    >
                      <option [ngValue]="null" disabled selected>
                        Pick one...
                      </option>
                      @for (structure of companyStructures; track structure) {
                        <option [ngValue]="structure">
                          {{ structure }}
                        </option>
                      }
                    </select>
                  </div>
                  @if (companyForm.controls.country.value !== 'CA') {
                    <div class="col-4">
                      <label for="ein" class="form-label"
                        >Company EIN (Tax ID #)</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="ein"
                        placeholder="__-_______"
                        [inputMask]="einMask"
                        formControlName="ein"
                      />
                    </div>
                  }
                  <div class="col-4">
                    <label for="fax" class="form-label">Office Fax</label>
                    <input
                      type="tel"
                      class="form-control"
                      id="phone"
                      placeholder="(___) ___-____"
                      [inputMask]="phoneMask"
                      formControlName="fax"
                    />
                  </div>
                  <div class="col-4">
                    <label for="country" class="form-label" requiredAsterisk
                      >Country of Operation</label
                    >
                    <select
                      id="country"
                      class="form-select"
                      formControlName="country"
                    >
                      <option [ngValue]="null" disabled selected>
                        Pick one...
                      </option>
                      @for (country of countriesMap | keyvalue; track country) {
                        <option [ngValue]="country.key">
                          {{ country.value }}
                        </option>
                      }
                    </select>
                  </div>
                  @if (userAccountType?.name !== 'Client') {
                    <div class="col-4 d-flex flex-column">
                      <label
                        for="operationStates"
                        class="form-label"
                        requiredAsterisk
                        >Operating States</label
                      >
                      <!--Custom Tag Field Component Below-->
                      <div class="d-flex flex-column dropdown">
                        <div
                          id="operation-states-dropdown"
                          class="form-control tag-field dropdown-toggle-override flex-grow-1"
                          (click)="
                            toggleOperationStatesDropdown();
                            $event.stopPropagation()
                          "
                          [class.show]="operationStatesDropdownOpen"
                          [class.prevent-input]="!hasValidEditPermission()"
                          role="button"
                          tabindex="0"
                        >
                          <span class="icon-container"
                            ><i
                              class="bi bi-chevron-down chevron-icon pull-right"
                            ></i
                          ></span>
                          @for (
                            option of companyOperationStates;
                            track option
                          ) {
                            <span
                              class="badge bg-primary badge-margin me-1"
                              contenteditable="false"
                              >{{ option.SubNationalDivision?.abbreviation }}
                              <i
                                class="bi bi-x-lg cursor-select"
                                (click)="
                                  deselectOption(option);
                                  $event.stopPropagation()
                                "
                              ></i
                            ></span>
                          }
                        </div>
                        <ul
                          class="dropdown-menu dropdown-menu-width vh-35 overflow-y-auto"
                          [class.show]="operationStatesDropdownOpen"
                          aria-labelledby="operation-states-dropdown"
                          (click)="$event.stopPropagation()"
                        >
                          @for (
                            option of availableOperationStates;
                            track option
                          ) {
                            <li>
                              <button
                                type="button"
                                class="dropdown-item cursor-select"
                                (click)="
                                  selectOption(option); $event.stopPropagation()
                                "
                              >
                                {{ option.abbreviation }}
                              </button>
                            </li>
                          }
                        </ul>
                      </div>
                      <!--Custom Tag Field Component Above-->
                    </div>
                  }
                  <!--If Client, only show tags-->
                  @if (userAccountType?.name === 'Client') {
                    <div class="col-4">
                      <label for="operationStates" class="form-label"
                        >Operating States</label
                      >
                      <div class="form-control">
                        @for (option of companyOperationStates; track option) {
                          <span
                            class="badge bg-primary badge-margin"
                            contenteditable="false"
                            >{{
                              option.SubNationalDivision?.abbreviation
                            }}</span
                          >
                        }
                      </div>
                    </div>
                  }
                  <div class="col-4">
                    <label for="website" class="form-label">Website</label>
                    <input
                      type="text"
                      class="form-control"
                      id="website"
                      placeholder="https://yoursite.com"
                      formControlName="website"
                    />
                  </div>
                  @if (userAccountType && userAccountType.name === 'Admin') {
                    <div class="col-4">
                      <label
                        for="packageType"
                        class="form-label"
                        requiredAsterisk
                        >Package Type</label
                      >
                      <select
                        id="packageType"
                        class="form-select"
                        (change)="onPackageTypeChange()"
                        [disabled]="!hasValidEditPermission()"
                        [(ngModel)]="packageType"
                        [ngModelOptions]="{ standalone: true }"
                      >
                        <option [ngValue]="null" disabled selected>
                          Pick one...
                        </option>
                        @for (type of packageTypes; track type) {
                          <option [ngValue]="type">
                            {{ type }}
                          </option>
                        }
                      </select>
                    </div>
                    <div class="col-4">
                      <div class="row">
                        <div class="col">
                          <label requiredAsterisk>ESign Provider</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <select
                            class="form-select"
                            formControlName="ESignProviderId"
                          >
                            @for (
                              ESignProvider of ESignProviders;
                              track ESignProvider
                            ) {
                              <option [ngValue]="ESignProvider.id">
                                {{ ESignProvider.name }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                @if (LoggedInUser.UserAccountType?.name !== 'Client') {
                  <div class="client-links">
                    @for (item of companyLinksMap | keyvalue; track item) {
                      <div class="client-link-row">
                        <span class="client-link-row__label">
                          {{ item.key }}
                        </span>
                        <div class="client-link-row__actions">
                          @if (item.value.copyURL) {
                            <button
                              type="button"
                              class="btn btn-outline btn-sm"
                              (click)="copyUrl(item.value)"
                            >
                              <i class="bi bi-clipboard me-1"></i>
                              Copy
                            </button>
                          }
                          @if (
                            item.value.updateURL && hasValidEditPermission()
                          ) {
                            <button
                              type="button"
                              class="btn btn-outline btn-sm"
                              (click)="updateUrl(item.value.formControl)"
                            >
                              <i class="bi bi-pencil me-1"></i>
                              Update
                            </button>
                          }
                          @if (item.value.openInNewTab) {
                            <button
                              type="button"
                              class="btn btn-outline btn-sm"
                              (click)="openLinkInNewTab(item.value.link)"
                            >
                              <i class="bi bi-box-arrow-up-right me-1"></i>
                              Open
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="col-12 col-lg-3">
                <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mb-0">Company logo</label>
                  @if (userAccountType?.name !== 'Client') {
                    <button
                      type="button"
                      class="btn btn-outline btn-sm"
                      (click)="updateLogo()"
                    >
                      <i class="bi bi-image me-1"></i>
                      Update logo
                    </button>
                  }
                </div>
                <div
                  class="mt-3 p-3 border border-1 rounded d-flex justify-content-center align-items-center logo-container"
                >
                  @if (company && logoUrl) {
                    <img src="{{ logoUrl }}" alt="company logo" />
                  }
                  @if (logoLoading) {
                    <span
                      class="spinner-border spinner-border-sm text-secondary"
                    ></span>
                  }
                  @if (!logoLoading && (!company || !logoUrl)) {
                    <span class="noLogo">No Logo</span>
                  }
                </div>
              </div>
            </div>

            @if (companyForm && companyForm.controls.country.value) {
              <h3>Address Information</h3>
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      @if (companyForm) {
                        <app-address-form
                          [addressForm]="companyForm.controls.MailingAddress"
                          [isMailing]="true"
                          [useMailingAddressTemplate]="true"
                          [country]="companyForm.controls.country.value"
                        ></app-address-form>
                      }
                    </div>
                  </div>
                  <div class="row row-padding">
                    <div class="col">
                      <div class="form-check">
                        <label
                          for="isMailingAndStreetSame"
                          class="form-check-label my-0"
                          >Street Address & Mailing Address are the same</label
                        >
                        <input
                          id="isMailingAndStreetSame"
                          type="checkbox"
                          class="form-check-input"
                          [disabled]="
                            userAccountType?.name === 'Client' ||
                            !hasValidEditPermission()
                          "
                          (change)="onIsMailingAndStreetSameChange()"
                          [checked]="isMailingAndStreetSame"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <app-address-form
                        [addressForm]="companyForm.controls.StreetAddress"
                        [isStreet]="true"
                        [useStreetAddressTemplate]="true"
                        [country]="companyForm.controls.country.value"
                      ></app-address-form>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </app-display-card>
      </div>
    </div>
  }

  @if (isClientListDataTabActive) {
    <div class="row pb-3">
      <div class="col">
        <app-display-card>
          <div class="inner-panel rounded">
            <h3>Client List Data</h3>
            <div class="row g-3">
              <div class="col-12">
                <div class="cld-contacts-head">
                  <label class="form-label mb-0">Contacts</label>
                  <button
                    type="button"
                    class="btn btn-outline btn-sm"
                    (click)="addContact()"
                  >
                    <i class="bi bi-plus-lg me-1"></i>
                    Add contact
                  </button>
                </div>

                @if (contactsList.length === 0) {
                  <p class="cld-contacts-empty">No contacts added yet.</p>
                }

                @for (contact of contactsList; track $index; let i = $index) {
                  <div class="cld-contact-row">
                    <select
                      class="form-select cld-contact-row__type"
                      [ngModel]="contact.type"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="updateContactField(i, 'type', $event)"
                    >
                      <option value="">Type…</option>
                      @for (type of contactTypes; track type) {
                        <option [value]="type">{{ type }}</option>
                      }
                    </select>
                    <input
                      class="form-control cld-contact-row__name"
                      [value]="contact.name"
                      (input)="
                        updateContactField(i, 'name', $any($event.target).value)
                      "
                      placeholder="Name"
                    />
                    <input
                      class="form-control cld-contact-row__phone"
                      [value]="contact.phone"
                      (input)="
                        updateContactField(
                          i,
                          'phone',
                          $any($event.target).value
                        )
                      "
                      placeholder="Phone"
                    />
                    <input
                      class="form-control cld-contact-row__email"
                      [value]="contact.email"
                      (input)="
                        updateContactField(
                          i,
                          'email',
                          $any($event.target).value
                        )
                      "
                      placeholder="Email"
                      type="email"
                    />
                    <button
                      type="button"
                      class="cld-contact-row__remove"
                      title="Remove contact"
                      aria-label="Remove contact"
                      (click)="removeContact(i)"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                }
              </div>
              <div class="col-4">
                <label for="clientVendorPrice" class="form-label"
                  >Vendor Price</label
                >
                <input
                  class="form-control"
                  id="clientVendorPrice"
                  formControlName="clientVendorPrice"
                />
              </div>
              <div class="col-4">
                <label for="vendorRegistrationPageUrl" class="form-label"
                  >Vendor Registration URL</label
                >
                <input
                  class="form-control"
                  id="vendorRegistrationPageUrl"
                  formControlName="vendorRegistrationPageUrl"
                />
              </div>
              <div class="col-4">
                <label for="hasVetProfessionals" class="form-label"
                  >Vet Professionals</label
                >
                <select
                  class="form-select"
                  id="hasVetProfessionals"
                  formControlName="hasVetProfessionals"
                >
                  @for (option of yesNoOptions; track option) {
                    <option [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-6">
                <label for="vendorPriceNotes" class="form-label"
                  >Vendor Price Notes</label
                >
                <textarea
                  class="form-control"
                  id="vendorPriceNotes"
                  formControlName="vendorPriceNotes"
                ></textarea>
              </div>
              <div class="col-6">
                <label for="generalClientNotes" class="form-label"
                  >General Client Notes</label
                >
                <textarea
                  class="form-control"
                  id="generalClientNotes"
                  formControlName="generalClientNotes"
                ></textarea>
              </div>

              <div class="col-12">
                <hr class="mb-1" />
                <h4 class="cld-subsection">Waivers</h4>
                <div class="row g-3">
                  <div class="col-4">
                    <label for="acceptsWaivers" class="form-label"
                      >Client Accepts Waivers</label
                    >
                    <select
                      class="form-select"
                      id="acceptsWaivers"
                      formControlName="acceptsWaivers"
                    >
                      @for (option of yesNoOptions; track option) {
                        <option [ngValue]="option.value">
                          {{ option.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="col-4">
                    <label for="acceptsAgreementRevisions" class="form-label"
                      >Accept Agreement Revisions</label
                    >
                    <select
                      class="form-select"
                      id="acceptsAgreementRevisions"
                      formControlName="acceptsAgreementRevisions"
                    >
                      @for (option of yesNoOptions; track option) {
                        <option [ngValue]="option.value">
                          {{ option.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="col-6">
                    <label for="descriptionOfOperations" class="form-label"
                      >Waiver Notes</label
                    >
                    <textarea
                      class="form-control"
                      id="descriptionOfOperations"
                      formControlName="descriptionOfOperations"
                    ></textarea>
                  </div>
                  <div class="col-6">
                    <label for="agreementRevisionNotes" class="form-label"
                      >Agreement Revision Notes</label
                    >
                    <textarea
                      class="form-control"
                      id="agreementRevisionNotes"
                      formControlName="agreementRevisionNotes"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <hr class="mb-1" />
                <h4 class="cld-subsection">Payment</h4>
                <div class="row g-3">
                  <div class="col-4">
                    <label for="usesThirdPartyBillPay" class="form-label"
                      >Third Party Bill Pay</label
                    >
                    <select
                      class="form-select"
                      id="usesThirdPartyBillPay"
                      formControlName="usesThirdPartyBillPay"
                    >
                      @for (option of yesNoOptions; track option) {
                        <option [ngValue]="option.value">
                          {{ option.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="col-4">
                    <label for="thirdPartyBillPayProvider" class="form-label"
                      >Provider</label
                    >
                    <input
                      class="form-control"
                      id="thirdPartyBillPayProvider"
                      formControlName="thirdPartyBillPayProvider"
                    />
                  </div>
                  <div class="col-6">
                    <label for="thirdPartyBillPayNotes" class="form-label"
                      >Bill Pay Notes</label
                    >
                    <textarea
                      class="form-control"
                      id="thirdPartyBillPayNotes"
                      formControlName="thirdPartyBillPayNotes"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col">
        <app-display-card>
          <div class="inner-panel rounded">
            <h3>Internal Notes</h3>

            @if (!internalNotesCompanyId) {
              <div class="alert alert-info mb-3">
                Save the client first to enable internal notes.
              </div>
            }

            @if (internalNotesCompanyId) {
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <textarea
                      class="form-control"
                      rows="3"
                      placeholder="Add an internal comment..."
                      [(ngModel)]="newInternalNote"
                      [ngModelOptions]="{ standalone: true }"
                    ></textarea>
                  </div>
                  <div class="d-flex justify-content-end mb-3">
                    <button
                      type="button"
                      class="btn btn-primary"
                      [disabled]="
                        isPostingInternalNote || !newInternalNote.trim()
                      "
                      (click)="addInternalNote()"
                    >
                      {{
                        isPostingInternalNote ? 'Posting...' : 'Post Comment'
                      }}
                    </button>
                  </div>
                </div>
              </div>

              @if (isInternalNotesLoading) {
                <div class="text-muted">Loading notes...</div>
              }

              @if (!isInternalNotesLoading && internalNotes.length === 0) {
                <div class="text-muted">No internal notes yet.</div>
              }

              @if (!isInternalNotesLoading && internalNotes.length > 0) {
                <div class="row">
                  <div class="col-12">
                    @for (
                      internalNote of internalNotes;
                      track internalNote.id
                    ) {
                      <div class="border rounded p-3 mb-2 bg-light">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <strong>{{
                            getInternalNoteAuthor(internalNote)
                          }}</strong>
                          <div class="d-flex align-items-center gap-2">
                            <small class="text-muted">{{
                              internalNote.createdAt | date: 'short'
                            }}</small>
                            <button
                              type="button"
                              class="btn btn-sm internal-note-delete-btn"
                              [disabled]="isDeletingInternalNote(internalNote)"
                              (click)="deleteInternalNote(internalNote)"
                            >
                              {{
                                isDeletingInternalNote(internalNote)
                                  ? 'Deleting...'
                                  : 'Delete'
                              }}
                            </button>
                          </div>
                        </div>
                        <div class="mt-2" style="white-space: pre-wrap">
                          {{ internalNote.note }}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </div>
        </app-display-card>
      </div>
    </div>
  }

  @if (isLifecycleDatesTabActive) {
    <div class="row pb-3">
      <div class="col">
        <app-display-card>
          <div class="inner-panel rounded">
            <h3>Lifecycle Dates</h3>
            <div class="row g-3">
              <div class="col-4">
                <label for="contractSignDate" class="form-label"
                  >Contract Sign Date
                  <span class="badge bg-secondary ms-1">Internal</span></label
                >
                <input
                  type="date"
                  class="form-control"
                  id="contractSignDate"
                  formControlName="contractSignDate"
                />
              </div>
              <div class="col-4">
                <label for="kickoffMeetingDate" class="form-label"
                  >Kickoff Meeting Date</label
                >
                <input
                  type="date"
                  class="form-control"
                  id="kickoffMeetingDate"
                  formControlName="kickoffMeetingDate"
                />
              </div>
              <div class="col-4">
                <label for="plannedLaunchDate" class="form-label"
                  >Planned Launch Date
                  <span class="badge bg-secondary ms-1">Internal</span></label
                >
                <input
                  type="date"
                  class="form-control"
                  id="plannedLaunchDate"
                  formControlName="plannedLaunchDate"
                />
              </div>
              <div class="col-4">
                <label for="actualLaunchDate" class="form-label"
                  >Actual Launch Date</label
                >
                <input
                  type="date"
                  class="form-control"
                  id="actualLaunchDate"
                  formControlName="actualLaunchDate"
                />
              </div>
              <div class="col-4">
                <label for="plannedCloseDownDate" class="form-label"
                  >Planned Close Down Date
                  <span class="badge bg-secondary ms-1">Internal</span></label
                >
                <input
                  type="date"
                  class="form-control"
                  id="plannedCloseDownDate"
                  formControlName="plannedCloseDownDate"
                />
              </div>
              <div class="col-4">
                <label for="actualCloseDownDate" class="form-label"
                  >Actual Close Down Date</label
                >
                <input
                  type="date"
                  class="form-control"
                  id="actualCloseDownDate"
                  formControlName="actualCloseDownDate"
                />
              </div>
              <div class="col-4">
                <label for="relaunchDate" class="form-label"
                  >Relaunch Date</label
                >
                <input
                  type="date"
                  class="form-control"
                  id="relaunchDate"
                  formControlName="relaunchDate"
                />
              </div>
              <div class="col-4">
                <label for="originalVendorFileCount" class="form-label"
                  >Original Vendor File Count</label
                >
                <input
                  type="number"
                  class="form-control"
                  id="originalVendorFileCount"
                  formControlName="originalVendorFileCount"
                  min="0"
                />
              </div>
              <div class="col-4">
                <label for="letterCadence" class="form-label"
                  >Letter Cadence</label
                >
                <select
                  class="form-select"
                  id="letterCadence"
                  formControlName="letterCadence"
                >
                  <option [ngValue]="null">Not Set</option>
                  <option value="1 Letter Series">1 Letter Series</option>
                  <option value="2 Letter Series">2 Letter Series</option>
                  <option value="3 Letter Series">3 Letter Series</option>
                  <option value="None">None</option>
                </select>
              </div>
              <div class="col-4">
                <label for="letterSender" class="form-label"
                  >Letter Sender</label
                >
                <select
                  class="form-select"
                  id="letterSender"
                  formControlName="letterSender"
                >
                  <option [ngValue]="null">Not Set</option>
                  <option value="VIVE Sent Letters">VIVE Sent Letters</option>
                  <option value="Client Sent Letters">
                    Client Sent Letters
                  </option>
                </select>
              </div>
            </div>
          </div>
        </app-display-card>
      </div>
    </div>
  }

  @if (userAccountType?.name !== 'Client') {
    <div class="action-row justify-end pb-3">
      @if (showCancelButton) {
        <button type="button" class="btn btn-ghost" (click)="cancelEdit()">
          Cancel
        </button>
      }
      <button type="button" class="btn btn-primary" (click)="save()">
        Save changes
      </button>
    </div>
  }
</div>
